/*
 * @Description: 计划支付单相关接口
 */

import https, { downloadExcel } from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { ContentType, Method } from 'axios-mapper'
import {
  PaymentExternalUpdateModel,
  PaymentSlipIdListModel,
  SlipWorkUpdatePaymentDate,
  PaymentSlipAcceptancePayment,
  PaymentSlipPageModel,
  SlipWorkUpdateReceiveBank,
  SlipWorkSplit,
  AccountBalanceModel,
  PaymentSlipPageParamModel,
  PaymentSlipRequestIdListModel,
  AvailableAcceptanceModel,
  PaymentSlipSetPaymentDateModel,
  PaymentSlipWorkModel,
  SlipWorkUpdatePaymentBank,
  SlipBufferPageParamModel,
  PaymentSlipBufferPageModel,
  SlipBufferSetPaymentDateModel,
  PaymentSlipBufferModel, PaymentSlipBufferDetailModel, PaymentSlipTotalAmountModel, PaymentSlipSumBySupplierPageModel,
  PaymentSlipGroupBySupplierPageModel, PaymentExternalBatchUpdateModel
} from '@/model/paymentSlip/paymentSlipModel'
import { CompanyInfoModel } from '@/model/master-data/companyModel'
import {
  PaymentSlipHistoryPageModel,
  PaymentSlipHistoryPageParamModel
} from '@/model/paymentSlip/paymentSlipHistoryModel'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/payment/slip'
const baseCompanyUrl = '/base/company'
const basePaymentSlipHistoryUrl = '/base/payment/slip/history'
const baseBufferUrl = '/base/payment/slip/buffer'

export const paymentReceiptFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/receipt'
}

export const getPaymentSlipPageList = (params: PaymentSlipPageParamModel) => {
  return https().request<RootObject<PaymentSlipPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getPaymentSlipSumBySupplierPageList = (params: PaymentSlipPageParamModel) => {
  return https().request<RootObject<PaymentSlipSumBySupplierPageModel>>(baseUrl + '/list/page/sumByVendor', Method.POST, params, ContentType.json)
}

export const getPaymentSlipGroupBySupplierPageList = (params: PaymentSlipPageParamModel) => {
  return https().request<RootObject<PaymentSlipGroupBySupplierPageModel>>(baseUrl + '/list/page/groupByVendor', Method.POST, params, ContentType.json)
}

export const exportPaymentSlip = (params: PaymentSlipPageParamModel): Promise<string | null> => {
  return downloadExcel(baseUrl + '/list/export', Method.POST, params)
}

export const exportPaymentSlipSumBySupplier = (params: PaymentSlipPageParamModel): Promise<string | null> => {
  return downloadExcel(baseUrl + '/sumByVendor/export', Method.POST, params)
}

export const setPaymentSlipPaymentDate = (params: PaymentSlipSetPaymentDateModel) => {
  return https().request<RootObject<number>>(baseUrl + '/set/paymentDate', Method.POST, params, ContentType.json)
}

export const cancelPaymentSlipApplication = (params: PaymentSlipRequestIdListModel) => {
  return https().request<RootObject<number>>(baseUrl + '/cancel', Method.POST, params, ContentType.json)
}

export const externalPayment = (param: PaymentExternalUpdateModel) => {
  return https().request<RootObject<number>>(baseUrl + '/external/pay', Method.POST, param, ContentType.json)
}

export const externalPaymentTest = (param: FormData) => {
  return https().request<RootObject<number>>(baseUrl + '/external/pay', Method.POST, param, ContentType.multipart)
}

export const batchExternalPayment = (param: PaymentExternalBatchUpdateModel) => {
  return https().request<RootObject<number>>(baseUrl + '/batch/external/pay', Method.POST, param, ContentType.json)
}

export const getPaymentSlipWorkList = () => {
  return https().request<RootObject<PaymentSlipWorkModel[]>>(baseUrl + '/work/list', Method.POST, undefined, ContentType.json)
}

export const getWorking = () => {
  return https().request<RootObject<PaymentSlipWorkModel[]>>(baseUrl + '/work/working', Method.POST, undefined, ContentType.json)
}

export const viewAndPay = (params: PaymentSlipIdListModel) => {
  return https().request<RootObject<PaymentSlipWorkModel[]>>(baseUrl + '/view/pay', Method.POST, params, ContentType.json)
}

export const updatePaymentBank = (params: SlipWorkUpdatePaymentBank) => {
  return https().request<RootObject<number>>(baseUrl + '/work/update/paymentBank', Method.POST, params, ContentType.json)
}

export const updateReceiveBank = (params: SlipWorkUpdateReceiveBank) => {
  return https().request<RootObject<number>>(baseUrl + '/work/update/receiveBank', Method.POST, params, ContentType.json)
}

export const updatePaymentDate = (params: SlipWorkUpdatePaymentDate) => {
  return https().request<RootObject<number>>(baseUrl + '/work/update/paymentDate', Method.POST, params, ContentType.json)
}

export const removePaymentSlipWork = (id: number) => {
  return https().request<RootObject<number>>(baseUrl + '/work/remove/paymentSlipWork/' + id, Method.POST, undefined, ContentType.json)
}

export const splitPaymentSlipWork = (params: SlipWorkSplit) => {
  return https().request<RootObject<number>>(baseUrl + '/work/split', Method.POST, params, ContentType.json)
}

export const cancelSplitPaymentSlipWork = (id: number) => {
  return https().request<RootObject<number>>(baseUrl + '/work/cancelSplit/' + id, Method.GET, undefined, ContentType.json)
}

export const submitPaymentSlipWork = () => {
  return https().request<RootObject<number>>(baseUrl + '/work/submitWork', Method.POST, undefined, ContentType.json)
}

export const getCompanyByCompanyCode = (companyCode: string) => {
  return https().request<RootObject<CompanyInfoModel>>(baseCompanyUrl + '/get/companyCode/' + companyCode, Method.GET, undefined, ContentType.json)
}

export const getAvailableAcceptance = () => {
  return https().request<RootObject<AvailableAcceptanceModel[]>>(baseUrl + '/acceptance/available/all', Method.GET, undefined, ContentType.json)
}

export const getPaymentSlipHistoryPageList = (params: PaymentSlipHistoryPageParamModel) => {
  return https().request<RootObject<PaymentSlipHistoryPageModel>>(basePaymentSlipHistoryUrl + '/list', Method.POST, params, ContentType.json)
}

export const acceptancePayment = (params: PaymentSlipAcceptancePayment) => {
  return https().request<RootObject<number>>(baseUrl + '/work/acceptancePayment', Method.POST, params, ContentType.json)
}

export const checkBalance = () => {
  return https().request<RootObject<AccountBalanceModel[]>>(baseUrl + '/work/checkBalance', Method.GET, undefined, ContentType.json)
}

export const getSlipBufferDetail = (id: string) => {
  return https().request<RootObject<PaymentSlipBufferDetailModel>>(baseBufferUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getSlipBufferPageList = (params: SlipBufferPageParamModel) => {
  return https().request<RootObject<PaymentSlipBufferPageModel>>(baseBufferUrl + '/list', Method.POST, params, ContentType.json)
}

export const updateSlipBufferPaymentDate = (params: SlipBufferSetPaymentDateModel) => {
  return https().request<RootObject<number>>(baseBufferUrl + '/update/paymentDate', Method.POST, params, ContentType.json)
}

export const cancelSlipBufferApplication = (params: PaymentSlipRequestIdListModel) => {
  return https().request<RootObject<number>>(baseBufferUrl + '/cancel', Method.POST, params, ContentType.json)
}

export const willSubmitPayment = () => {
  return https().request<RootObject<PaymentSlipBufferModel[]>>(baseBufferUrl + '/willSubmitPayment', Method.GET, undefined, ContentType.json)
}

export const getSlipBufferTotalAmount = () => {
  return https().request<RootObject<PaymentSlipTotalAmountModel[]>>(baseBufferUrl + '/total-amount', Method.GET, undefined, ContentType.json)
}

export const getPaymentSlipTotalAmount = () => {
  return https().request<RootObject<PaymentSlipTotalAmountModel[]>>(baseUrl + '/work/total-amount', Method.GET, undefined, ContentType.json)
}
